module.exports = __webpack_public_path__ + "static/scale-model-of-kansas-city-walking-tours-in-kansas-city-missouri-f71d1d6ca99d7e5e78332bfaa30feec6.png";